import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/PlannedMaintenanceCalendarActions";
import * as api from "../../api/PlannedMaintenanceCalendarApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";

function* getTaskList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTaskList(action.payload);
        yield put(actions.setTaskList(data || undefined));
    } catch (error) {
        yield put(actions.setTaskList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTaskSchedule(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTaskSchedule(action.payload);
        yield put(actions.setTaskSchedule(data || undefined));
    } catch (error) {
        yield put(actions.setTaskSchedule(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getupdateTaskDate(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getupdateTaskDate(action.payload);
        yield put(actions.setupdateTaskDate(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setupdateTaskDate(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getStatusList(action) {
    try {
        const { data } = yield api.getStatusList(action.payload);
        yield put(actions.setStatusList(data || undefined));
    } catch (error) {
        yield put(actions.setStatusList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTaskDetailById(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTaskDetailById(action.payload);
        yield put(actions.setTaskDetailById(data || undefined));
    } catch (error) {
        yield put(actions.setTaskDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAreaList() {
    try {
        const { data } = yield api.getAreaList();
        yield put(actions.setAreaList(data || undefined));
    } catch (error) {
        yield put(actions.setAreaList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEquipmentSubListById() {
    try {
        const { data } = yield api.getEquipmentSubListById();
        yield put(actions.setEquipmentSubListById(data || undefined));
    } catch (error) {
        yield put(actions.setEquipmentSubListById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getListMaintenanceType() {
    try {
        const { data } = yield api.getListMaintenanceType();
        yield put(actions.setListMaintenanceType(data || undefined));
    } catch (error) {
        yield put(actions.setListMaintenanceType(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getList(action) {
    try {
        const { data } = yield api.getList(action.payload);
        yield put(actions.setList(data || undefined));
    } catch (error) {
        yield put(actions.setList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getMainListByAreaID(action) {
    try {
        const { data } = yield api.getMainListByAreaID(action.payload);
        yield put(actions.setMainListByAreaID(data || undefined));
    } catch (error) {
        yield put(actions.setMainListByAreaID(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSubListById(action) {
    try {
        const { data } = yield api.getSubListById(action.payload);
        yield put(actions.setSubListById(data || undefined));
    } catch (error) {
        yield put(actions.setSubListById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_STATUS_LIST_FOR_MAINTENANCE_CALENDER, getStatusList);
    yield takeEvery(actions.Types.GET_TASKS_LIST_FOR_MAINTENANCE_CALENDER, getTaskList);
    yield takeEvery(actions.Types.GET_TASK_SCHEDULE_FOR_MAINTENANCE_CALENDAR, getTaskSchedule);
    yield takeEvery(actions.Types.GET_UPDATE_TASK_DATE, getupdateTaskDate);
    yield takeEvery(actions.Types.GET_AREA_LIST_FOR_MAINTENANCE_CALENDER, getAreaList);
    yield takeEvery(actions.Types.GET_TASK_DETAIL_BY_ID, getTaskDetailById);
    yield takeEvery(actions.Types.GET_EQUIPMENT_SUB_LIST_BY_ID, getEquipmentSubListById);
    yield takeEvery(actions.Types.GET_LIST_MAINTATENANCE_TYPE, getListMaintenanceType);
    yield takeEvery(actions.Types.GET_POOL_LIST_FOR_MAINTENANCE_CALENDER, getList);
    yield takeEvery(actions.Types.GET_MAIN_LIST_BY_AREA_ID, getMainListByAreaID);
    yield takeEvery(actions.Types.GET_SUB_LIST_BY_AREA_ID, getSubListById);
}

const PlannedMaintenanceCalendarSaga = [fork(watchAll)];
export default PlannedMaintenanceCalendarSaga;
